import { useState, useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useRepairHistoryModel } from "../repairHistoryModel";
import { tableSize } from "@/utils/constants";
import { VehicleRepairHistoryModel } from "@/views/commonModule/vehicleRepairHistoryModel"
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import YhTootip from "@/components/YhTootip";

export function DataTable() {
    const { dataSource, pgCfg, loading, loadData } = useRepairHistoryModel();
    const [detail, setDetail] = useState<{ visible: boolean, licensePlate: string }>({ visible: false, licensePlate: "" });

    useEffect(() => {
        loadData()
    }, [])

    const defaultColumns: ColumnsType<any> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        },
        {
            title: '操作',
            width: 60,
            align: 'center',
            render: (text: any, record: any,) => {
                return <YhAuth resCode={ResourceAuthEnum.STT_RH_VW}>
                    <YhTootip text="维修历史" style={{ width: 60 }} onClick={() => { setDetail({ visible: true, licensePlate: record.licensePlate }); }} />
                </YhAuth>
            }
        },
        {
            title: '车辆牌照',
            dataIndex: 'licensePlate',
            width: 150,
            align: 'center',
        },
        {
            title: '客户名称',
            dataIndex: 'customerName',
            width: 250,
            align: 'center',
        },
        {
            title: '车辆品牌',
            width: 160,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '车辆类型',
            width: 150,
            dataIndex: 'vehicleTypeName',
            align: 'center',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,
        },
        {
            title: '维修次数',
            dataIndex: 'repairTimes',
            width: 80,
            align: 'center',
        },
        {
            title: '最近一次维修时间',
            dataIndex: 'lastRepairTime',
            width: 150,
            align: 'center',
        },
        {
            title: '维修累计消耗工时',
            dataIndex: 'workHour',
            width: 150,
            align: 'center',
        },
        {
            title: '维修累计消耗配件',
            dataIndex: 'materialNum',
            width: 150,
            align: 'center',
        },
        {
            title: '累计消耗工时金额',
            dataIndex: 'workingHoursAmount',
            width: 150,
            align: 'center',
        },
        {
            title: '累计消耗配件金额',
            dataIndex: 'materialScienceAmount',
            width: 150,
            align: 'center',
        },
    ];

    return (
        <>
            <Table
                bordered
                style={{ cursor: "pointer" }}
                loading={loading}
                size={tableSize}
                rowKey={record => record.licensePlate as string}
                columns={defaultColumns}
                dataSource={dataSource}
                pagination={{
                    showSizeChanger: true,
                    ...pgCfg,
                    defaultPageSize: 25,
                    pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                    position: ["bottomRight"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}
            />
            <VehicleRepairHistoryModel
                visible={detail.visible}
                licensePlate={detail.licensePlate}
                onCancel={() => { setDetail({ visible: false, licensePlate: "" }); }}
            />
        </>
    )
}
